/**
 * Calculates the total estimated time for all tasks within a specific examination.
 *
 * @param {Examination[]} examinations - Array of examination objects.
 * @param {string} examinationId - The ID of the examination to calculate the total estimated time for.
 * @returns {number} - The total estimated time for the specified examination.
 *
 * Usage:
 * const totalTime = getTotalEstimatedTime(examinations, 'exam123');
 * console.log(`Total estimated time: ${totalTime} minutes`);
 */
import { Examination, Task } from "graphql/types"

export const getTotalEstimatedTime = (
  examinations: Examination[],
  examinationId: string
): number => {
  const examination = examinations.find((exam) => exam.id === examinationId)

  if (!examination || !examination.tasks) {
    return 0
  }

  const totalEstimatedTime = examination.tasks.reduce(
    (taskTotal: number, task: Task) => {
      return taskTotal + task.estimatedTime
    },
    0
  )

  return totalEstimatedTime
}
